class CreditworthinessOfLoanController {
  constructor() {
  }
}

export default CreditworthinessOfLoanController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthinessOfLoan/creditworthinessOfLoan.controller.js